import React, {Fragment, useState, useEffect} from 'react'
import {Form, Button, Icon} from 'semantic-ui-react'
import { useFirestore, useFirebase } from 'react-redux-firebase';
import {env} from '../../../constants/Environment';
import ImagePicker from '../../imagepicker/picker';

const moment = require('moment');

export const Image = (props) => {
    const [content, setContent] = useState('');
    const [isEditable, setIsEditable] = useState(true);
    const [event, setEvent] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [showChooseImage, setShowChooseImage] = useState(false);
    const firestore = useFirestore();


    useEffect(() => {

    }, [showChooseImage]);

    /*useEffect(() => {
        if(event !== null){
            let uid = event.uid;
            let marketUid = event.markets[0].uid;

            props.onChange({
                uid: uid,
                market: marketUid
            });
        }
    }, [event]);

    useEffect(() => {
        if(typeof props.payload !== 'undefined' && props.payload !== null){
            if(event === null || event.uid !== props.payload.uid || event.markets[0].uid !== props.payload.market){
                setIsLoading(true);

                (async () => {
                    let doc = await firestore.collection('environments/' + env + '/programs/0/oe').doc(props.payload.uid).get();
                    if(doc.exists){
                        let eventData = doc.data();
                        setIsLoading(false);

                        setEvent({
                            ...eventData,
                            markets: [
                                eventData.markets.find((m) => m.uid === props.payload.market)
                            ]
                        });
                    }
                })();
            }
        }
    }, [props.payload]);*/

    return (
        <div style={{
            /*boxShadow: '0px 3px 7px rgba(0, 0, 0, 0.2)',
            borderRadius: '3px',*/
            maxWidth: '500px',
            //padding: '15px',
            position: 'relative',
            overflow: 'hidden'
            //backgroundColor: 'rgba(0, 0, 0, 0.05)'
        }}>
            {
                showChooseImage?
                    <ImagePicker channel="app-push" chooseImage={(image) => {
                        setShowChooseImage(false);
                        props.onChange(image);
                    }} />
                :
                    (typeof props.payload !== 'undefined' && props.payload !== null && typeof props.payload.url !== 'undefined')?
                        <div>
                            <img src={props.payload.url} style={{
                                width: '100%'
                            }} />
                            {
                                props.readonly?
                                    null
                                :
                                    <a style={{
                                        display: 'block',
                                        marginTop: '0.5em',
                                        paddingTop: '1em',
                                        color: '#777777',
                                        cursor: 'pointer',
                                        textAlign: 'right'
                                    }} onClick={(e) => setShowChooseImage(true)}>
                                        <Icon circular name="pencil" /> Ein anderes Bild auswählen ›
                                    </a>
                                }
                        </div>
                    :                    
                        <div style={{
                            width: '100%',
                            height: '150px',
                            backgroundColor: '#EEEEEE',
                            color: '#AAAAAA',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontStyle: 'italic',
                            flexDirection: 'column',
                            border: '2px dashed #DDDDDD'
                        }} onClick={(e) => {
                            setShowChooseImage(true);
                        }}>
                            Es wurde noch kein Bild ausgewählt.
                            <div style={{paddingTop: '1em'}}>
                                <Button>Bild auswählen…</Button>
                            </div>
                        </div>
            }

        </div>
    )
}